<template>
  <div class="part-item" :style="styleCommon"></div>
</template>
<script>
export default {
  props: {
    styles: {
      default: () => {},
      required: false,
      type: Object,
    },
  },
  computed: {
    styleCommon() {
      return Object.assign(
        {},
        {
          width: '100px',
          height: '100px',
          background: '#E5E5EB',
          'border-radius': '8px',
        },
        this.styles
      );
    },
  },
};
</script>
